import moment from 'moment';
import React, {useEffect, useState} from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import '../assets/css/style.css';
import {Month, Week} from '../components';
import Loading from '../components/Loading';
import Header from './header';

const Home = () => {
    const [selectedDay, setSelectedDay] = useState(moment());
    const [weekOfMonth, setWeekOfMonth] = useState(1);
    const [dayInWeek, setDayInWeek] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const keys = [{
        key: "month",
        title: "月",
        view: <Month key={"month"} setIsLoading={setIsLoading} onChange={(value, week) => {
            setValue(keys[1].key);
            setSelectedDay(value);
            setWeekOfMonth(week);
        }}/>
    }, {
        key: "week",
        title: "週",
        view: <Week key={"week"} selectedDay={selectedDay} weekOfMonth={weekOfMonth} setIsLoading={setIsLoading}
                    dayInWeek={dayInWeek} setWeekOfMonth={setWeekOfMonth} setSelectedDay={setSelectedDay} />
    }];
    const [value, setValue] = useState(keys[0].key);

    useEffect(() => {
        const currentMonth = moment(selectedDay).startOf('months');
        const day = currentMonth.day();
        const prevMonth = moment(currentMonth).subtract(1, 'months').endOf("month");
        const days = [[]];
        let nextDays = 0;
        let week = 0;
        for (let index = 0; index < 7; index++) {
            if (nextDays + 1 == selectedDay.date()) week = 1;
            if (index < day) {
                days[0].unshift({disable: true, value: prevMonth.date() - index});
            } else {
                days[0].push({disable: false, value: nextDays + 1});
                nextDays++;
            }
        }
        
        const lastMonth = moment(currentMonth).endOf('month');
        let position = 0;
        for (let index = nextDays + 1; index <= lastMonth.date(); index++) {
            if (days[position].length < 7) {
                days[position].push({disable: false, value: index});
            } else {
                days.push([{disable: false, value: index}]);
                position++;
            }
            if (index == selectedDay.date()) week = position + 1;
        }
        const remainLength = 7 - days[days.length - 1].length;
        if (days[days.length - 1].length < 7) {
            for (let index = 1; index <= remainLength; index++) {
                days[days.length - 1].push({disable: true, value: index});
            }
        }
        setWeekOfMonth(week);
        setDayInWeek(days);
    }, [weekOfMonth, selectedDay]);

    return (
        <>
            <Header/>
            <div className="pxc-5 ptc-5">
                <Tabs className="mb-2" activeKey={value} onSelect={(key) => {
                    setValue(key);
                }}>
                    {
                        keys.map(item => (
                            <Tab key={item.key} eventKey={item.key} title={item.title}>
                                {item.view}
                            </Tab>
                        ))
                    }
                </Tabs>
            </div>
            {
                isLoading && <Loading/>
            }
        </>
    );
}

export default Home;